import {
  Empty,
  EmptyDescription,
  EmptyHeadline,
  EmptyDrawerIcon,
} from '@frontend/components';

import { useOrderListSearchParams } from 'modules/orders/listPage/hooks';
import type { OrderListTabId } from 'modules/orders/listPage/types';

import { TAB_ID_TO_EMPTY_TEXT_MAP } from './const';

export type TableEmptyContentProps = {
  tabId: OrderListTabId;
};

export const TableEmptyContent = ({ tabId }: TableEmptyContentProps) => {
  const { isFiltered, isSearched } = useOrderListSearchParams();

  const isSearchedOrFiltered = isFiltered || isSearched;

  const { headline } = TAB_ID_TO_EMPTY_TEXT_MAP[tabId];

  return (
    <Empty>
      <EmptyDrawerIcon />
      <EmptyHeadline>{headline}</EmptyHeadline>
      {isSearchedOrFiltered && (
        <EmptyDescription>
          Adjust your filters or search to find orders.
        </EmptyDescription>
      )}
    </Empty>
  );
};
